/*
 *  This file hrone-network-helper.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 20203
 *  (C) 2015-20203. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */



import { Injectable, inject } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { TLoginTokenResponse } from '../../models/common.models';
import { ConfigurationService } from '../configuration.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class HroneNetworkHelperService {
  _config = inject(ConfigurationService);
  _http = inject(HttpClient);
  private readonly _router = inject(Router);
  apiCalled = false;
  delaywhen$ = new BehaviorSubject(false);
  refreshingToken!: boolean;
  tokenBs: BehaviorSubject<TLoginTokenResponse | null> = new BehaviorSubject(this.getAuthLogin());



  public LoginUnAuthorized(url:string, param:{[key:string]:any} | string): Observable<any> {
    const headers = this.getLoginHeaders();
    return this._http
      .post(this._config.base_auth_url + url, param, { headers: headers })

  }

  getLoginHeaders():HttpHeaders {
    const dcStr = localStorage.getItem('domainCode');
    const dc =   dcStr ?? this._config.domainCode;
    return new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      domainCode: dc,
      AccessMode: 'W'
    });
  }

  getRefreshToken(): Observable<TLoginTokenResponse> {
    const authlogin = this.getAuthLogin();
    const url = "/oauth2/token";
    const logOnUserDetails = JSON.parse(localStorage.getItem('logOnUserDetails') || '{}');
    const username = localStorage.getItem('logOnUserName') ? localStorage.getItem('logOnUserName') : logOnUserDetails ? logOnUserDetails.officialEmail : '';
    const domainCode = localStorage.getItem('domainCode') ? localStorage.getItem('domainCode') : this._config.domainCode;
    const refreshId = authlogin ? authlogin.refresh_token:"";
    const body = `refreshId=${refreshId}&companyDomainCode=${domainCode ?? ""}&grant_type=refresh_token&username=${username||''}`;
    return this.LoginUnAuthorized(url, body);
  }
  logout():void {
    this.logOutFromWeb();
  }
  setLoginAuth(data:{[key:string]:any}):void {
    localStorage.setItem("authlogin", JSON.stringify(data));
  }

clearLocalStorage():void {
    localStorage.removeItem('authlogin');
    localStorage.removeItem('newAddedMneu');
    localStorage.removeItem('rawMenusWithActions');
    localStorage.removeItem('socketId');
    localStorage.removeItem('rawMenus');
    localStorage.removeItem('logOnUserDetails');
    localStorage.removeItem('whiteLabels');
    localStorage.removeItem('uid');
    localStorage.removeItem('GC_Accesstoken');
    localStorage.removeItem('requestSource');
    localStorage.removeItem('selectedHRDeskSearch');
    localStorage.removeItem('samlSessionIndex');
    localStorage.removeItem('contactDialogShown');
    if(environment.redirectToMicro){
      window.location.href = environment.loginRedirectUrl
     } else {
      this._router.navigate(['/login']);
     }
    localStorage.removeItem('newAddedMenu');
    localStorage.removeItem('notificationFetched');
    localStorage.removeItem('hasSeenMobileDialog');
    localStorage.removeItem('recent_report_searches');
    localStorage.removeItem('recent_report_searches_team');
    localStorage.removeItem('cart');
    // can not inject auth service here it will cause circular dependency.
    // if (this.employeeInfoAfterLogin?.employeeStatusId == 7) {
    //   localStorage.removeItem('recent_enterprise_search');
    // }
  }

  logOutFromWeb():void {
    const authlogin = this.getAuthLogin();
    const refresh_token = authlogin?.refresh_token ?? '';
    const firebaseId = localStorage.getItem('fcmToken') ?? '';
    const url = `/api/LogOnUser/Logout`;
    const userDetails = JSON.parse(localStorage.getItem('logOnUserDetails')|| '{}');
    const domainCode = localStorage.getItem('domainCode') ?? '';
    if(!refresh_token){
      this.handleLogout();
      return;
    }
    this._http.put(this._config.base_url + url,{refreshId:refresh_token,firebaseId,domainCode:domainCode ? domainCode : userDetails ? userDetails.domainCode: '',logOnUserId:userDetails ? userDetails.employeeId:''})
    .subscribe({
      next:()=>{
        this.handleLogout();
      },
      error:()=>{
        this.handleLogout();
      }
    });

  }


  private handleLogout():void {
    this.clearLocalStorage();
    localStorage.removeItem('launchDialog');
  }

  getAuthLogin(): TLoginTokenResponse | null {
    return JSON.parse(localStorage.getItem("authlogin") || '{}');
  }

}
